export default {
  never: 'Nigdy',
};
